import React from 'react';
import { IonBadge } from '@ionic/react';
import { PlatformFeature } from '../api';
import { useSubscription } from '../SubscriptionProvider';

// When a `feature` is provided, the badge only shows for users who don't have
// access to it (i.e. it's a Pro-gated feature for them). Without a feature it
// always renders, preserving the previous behaviour.
const ProBadge: React.FC<{ feature?: PlatformFeature }> = ({ feature }) => {
  const { hasFeature } = useSubscription();

  if (feature && hasFeature(feature)) {
    return null;
  }

  return (
    <IonBadge color="warning" style={{ marginLeft: 4 }}>
      Pro
    </IonBadge>
  );
};

export default ProBadge;
